import { Component } from 'base/js/aem';
import { createApp } from 'vue';
import HelloBarTemplate from './HelloBar.vue';
import { Breakpoints } from 'base/js/templates/general/breakpoints.js';

class HelloBar extends Component {
    init() {
        this.showHelloBar();
        this.adjustNavTopProp();
    }
    showHelloBar() {
        const helloBarPlaceHolder = this.element.querySelector('[data-hello-bar-json]');
        if (helloBarPlaceHolder) {
            const helloBarData = JSON.parse(helloBarPlaceHolder.dataset.helloBarJson);
            const previousText = helloBarPlaceHolder.dataset.previousText;
            const nextText = helloBarPlaceHolder.dataset.nextText;
            const openTabText = helloBarPlaceHolder.dataset.openTabText;
            const props = {
                helloBarData: helloBarData,
                previousText: previousText,
                nextText: nextText,
                openTabText: openTabText
            };
            const helloBarComponent = createApp(HelloBarTemplate, props);
            helloBarComponent.mount(helloBarPlaceHolder);
        }
    }
    adjustNavTopProp() {
        const helloBarElem = this.element;
        const navBarElem = document.querySelector('.navbar.navbar-expand-xl');
        const navBarMenu = document.querySelector('.navbar-nav-container');
        let helloBarHeight = helloBarElem.offsetHeight;

        if (helloBarElem && navBarElem && navBarMenu && helloBarHeight > 0) {
            const updateNavTop = () => {
                if (Breakpoints.isNarrowerThan('xl')) {
                    let elemRect = helloBarElem.getBoundingClientRect();
                    let navBarRect = navBarElem.getBoundingClientRect();
                    let elemRectHeight = elemRect.height;
                    let rectNavBarHeight = navBarRect.height;
                    navBarMenu.style.top = `${ elemRectHeight + rectNavBarHeight }px`;
                } else {
                    navBarMenu.style.top = '';
                }
            };

            updateNavTop();
            window.addEventListener('resize', updateNavTop);
        }
    }
}

export { HelloBar };
